import { createRequestTypes } from 'common/websocket-redux';

export const GET_DASHBOARDS = createRequestTypes('hr-admin/GET_DASHBOARDS');

export const GET_DASHBOARD_URL = createRequestTypes(
  'hr-admin/GET_DASHBOARD_URL',
);
